import styled from 'styled-components';

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

export const Content = styled.main`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 24px;
  background: #f5f7fa;
  padding: 24px 16px;

  @media (max-width: 640px) {
    padding-top: 72px; /* altura aproximada do header */
  }
`;

export const Footer = styled.footer`
  display: flex;
  padding: 16px;
  background: #fff;
  border-top: 1px solid #e0e0e0;

  @media (max-width: 640px) {
    padding: 12px 8px; /* encosta mais nas bordas */
  }
`;

export const Button = styled.button`
  background: ${({ theme }) => theme.primary};
  color: #fff;
  padding: 8px 30px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;

  &:hover {
    opacity: 0.8;
  }

  &:disabled {
    background: #9ca3af !important;
    cursor: not-allowed;
    opacity: 1;
  }

  @media (max-width: 640px) {
    flex: 1; /* cada botão ocupa metade */
    padding: 12px 0; /* alvo de toque maior */
    font-size: 15px;
  }
`;

// formulario

export const FormWrapper = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  max-width: 900px;
  width: 100%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);

  @media (max-width: 640px) {
    padding: 16px;
  }
`;

export const Title = styled.h2`
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 24px;
  color: #9ca3af; // ajustar para o thema depois
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px 20px;
  grid-template-areas:
    'banco   .'
    'conta   agencia';

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    grid-template-areas:
      'banco'
      'conta'
      'agencia';

    > div {
      grid-column: 1 / -1 !important;
    }
  }
`;

export const Field = styled.div`
  min-width: 0; /* evita overflow no grid */
  display: flex;
  flex-direction: column;

  label {
    font-size: 14px;
    color: #9ca3af;
    margin-bottom: 6px;
  }
  input {
    width: 100%;
    box-sizing: border-box;
    padding: 10px 12px;
    border: 1px solid #d0d5dd;
    border-radius: 6px;
    font-size: 15px;

    &:focus,
    &:focus-visible {
      outline: none;
      border-color: ${({ theme }) => theme.primary};
      box-shadow: 0 0 0 3px ${({ theme }) => theme.selectedDiv};
    }
  }
`;

export const ButtonsRow = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 640px) {
    gap: 12px;
  }
`;

export const BackButton = styled(Button)`
  background: #fff;
  color: ${({ theme }) => theme.primary};
  border: 1px solid ${({ theme }) => theme.primary};

  &:hover:not(:disabled) {
    background: rgba(0, 0, 0, 0.02);
  }

  &:disabled {
    background: #9ca3af !important;
    color: #fff !important;
    border-color: #9ca3af !important;
    cursor: not-allowed;
    opacity: 1;
  }
`;

// parte dos steps

export const StepperWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 80px;
  max-width: 980px;
  width: 100%;
  margin: 80px auto 8px;
  padding: 0 8px;

  @media (max-width: 640px) {
    justify-content: flex-start;
    gap: 16px;
    margin: 12px auto 0;
    padding: 0 8px;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }
  @media (max-width: 640px) {
    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const StepItem = styled.button<{ active?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background: transparent;
  border: 0;
  padding: 0;
  user-select: none;
  cursor: default;

  /* impede encolher e habilita snap */
  flex: 0 0 auto;
  scroll-snap-align: center;

  .circle {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: grid;
    place-items: center;
    font-weight: 700;
    font-size: 14px;
    border: 2px solid
      ${({ active, theme }) => (active ? theme.primary : '#e5e7eb')};
    background: ${({ active, theme }) => (active ? theme.primary : '#f3f4f6')};
    color: ${({ active }) => (active ? '#fff' : '#6b7280')};

    @media (max-width: 640px) {
      width: 28px;
      height: 28px;
      font-size: 13px;
    }
  }
  .label {
    font-size: 16px;
    font-weight: ${({ active }) => (active ? 700 : 500)};
    color: ${({ active }) => (active ? '#111827' : '#6b7280')};
    @media (max-width: 640px) {
      font-size: 13px;
      white-space: nowrap;
    }
  }
`;

export const CustomizationToggle = styled.button`
  background: none;
  border: none;
  color: #6b7280;
  cursor: pointer;
  font-size: 14px;
  padding: 0;
`;

export const CustomizationBody = styled.div`
  margin-top: 16px;
`;

export const CustomizationError = styled.span`
  display: block;
  color: #dc2626;
  font-size: 12px;
  margin-top: 12px;
`;
